import { NgModule } from '@angular/core';
import {MatDialogModule,} from "@angular/material";
import {CommonModule} from '@angular/common';
import {ConfirmComponent} from "./confirm/confirm.component";
import {CredentialDialogComponent} from "./credential/credential.component";
import {FormsModule} from "@angular/forms";
import {ThirdPartyDialogComponent} from "./third-party/third-party-dialog.component";
import {FreelancerDialogComponent} from "./freelancer/freelancer-dialog.component";
import {OutsourcingDialogComponent} from "./outsourcing/outsourcing-dialog.component";
import {FilterComponent} from './filter/filter.component';

@NgModule({
    imports: [MatDialogModule, CommonModule, FormsModule],
    declarations: [
        ConfirmComponent,
        CredentialDialogComponent,
        ThirdPartyDialogComponent,
        FreelancerDialogComponent,
        OutsourcingDialogComponent,
        FilterComponent
    ],
    entryComponents: [
        ConfirmComponent,
        CredentialDialogComponent,
        ThirdPartyDialogComponent,
        FreelancerDialogComponent,
        OutsourcingDialogComponent,
        FilterComponent
    ]
})
export class DialogsModule { }



// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/dialogs/dialogs.module.ts